import React from 'react';
import { useSelectAppSettings } from 'app/store/appSettings/selectors';
import { useSelectIsAppModeNewportSingleWidget } from 'app/store/general/selectors';
import { useDispatchUpdateAppSettings } from 'app/store/appSettings/dispatcher';
import AppSettingsEditor from 'appToolbar/AppSettingsEditor';
import {
    NumericValueEditor,
    ToggleInput,
} from '@instinet-analytics/semantic-ui-components';

import { useOrderVolumeProfileConfigSlice } from '../../store/configuration/configSlice';
import { useToggleConfigOption } from 'widgets/store/configuration/hooks.ts';

export default function OrderVolumeProfileSettings() {
    const {
        config: { barSizeInMinutes },
        dispatchConfigChanged,
    } = useOrderVolumeProfileConfigSlice();
    const isAppModeNewportSingleWidget =
        useSelectIsAppModeNewportSingleWidget();
    const appSettings = useSelectAppSettings();
    const dispatchUpdateAppSettings = useDispatchUpdateAppSettings();

    const onBarSizeChanged = (nextBarSizeInMinutes: number) => {
        dispatchConfigChanged({ barSizeInMinutes: nextBarSizeInMinutes });
    };

    const { value: includeAuctions, toggle: toggleIncludeAuctions } =
        useToggleConfigOption('includeAuctions');
    const { value: custom, toggle: toggleCustom } =
        useToggleConfigOption('custom');
    const { value: regular, toggle: toggleRegular } =
        useToggleConfigOption('regular');

    return (
        <div className="VolumeCurveSettings">
            <div className="group group-general">
                <div>
                    <div>Bar size in minutes</div>
                    <NumericValueEditor
                        value={barSizeInMinutes}
                        min={1}
                        onChange={onBarSizeChanged}
                    />
                </div>

                <div className="group-header ">
                    <div className="title">Include auctions</div>
                    <ToggleInput
                        checked={includeAuctions}
                        onToggle={toggleIncludeAuctions}
                    />
                </div>

                <div className="group-header ">
                    <div className="title">
                        Include continuous trading sessions
                    </div>

                    <ToggleInput checked={regular} onToggle={toggleRegular} />
                </div>

                <div className="group-header ">
                    <div className="title">Use special day trading curve</div>
                    <ToggleInput checked={custom} onToggle={toggleCustom} />
                </div>

                {isAppModeNewportSingleWidget && (
                    <AppSettingsEditor
                        appSettings={appSettings}
                        onAppSettingsChanged={dispatchUpdateAppSettings}
                        specifyVisibleControls={{
                            showChartHelp: true,
                            showTooltips: true,
                        }}
                    />
                )}
            </div>
        </div>
    );
}
